import { WorkflowStepCode } from '@exam-management/graphql';
import { LabelColor } from '@shared/components';

export const QUESTION_REVIEW_STATUS_COLOR = {
  [WorkflowStepCode.QuestionReviewTodo]: LabelColor.INFO,
  [WorkflowStepCode.QuestionReviewInReview]: LabelColor.WARNING,
  [WorkflowStepCode.QuestionReviewReviewed]: LabelColor.SUCCESS,
  [WorkflowStepCode.QuestionReviewDone]: LabelColor.SUCCESS,
};

export const QUESTION_REVIEW_STATUS_TEXT = {
  [WorkflowStepCode.QuestionReviewTodo]: 'Todo',
  [WorkflowStepCode.QuestionReviewInReview]: 'In Review',
  [WorkflowStepCode.QuestionReviewReviewed]: 'Reviewed',
  [WorkflowStepCode.QuestionReviewDone]: 'Done',
};
